export default __webpack_public_path__ + "static/media/nice2Light.d7f432d5.svg";